















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ComponentsFormFile extends Vue {
  @Prop({ type: String, default: '' })
  label?: string;

  @Prop({ type: Boolean, default: false })
  readonly required!: boolean;

  @Prop({ type: String, default: 'Выбрать файл...' })
  fileName: string;

  @Prop({ type: String, default: '' })
  text: string;

  @Prop({ type: String, default: '' })
  warnings: string;

  @Prop({ type: String, default: '' })
  errorText: string;

  @Prop({ type: [Object, Function], default: null })
  v: any;

  get vError() {
    return this.v && this.v.$error;
  }

  get fileNameClass() {
    const { fileName } = this;
    return fileName === 'Выбрать файл...';
  }

  get showText() {
    const { text, warnings } = this;
    return warnings ? warnings : text;
  }

  get attrText() {
    const { fileName, text, warnings } = this;
    return warnings ? warnings : fileName ? fileName : text;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/form/components/file/File.vue